import { useState } from 'react';
import ComicCard from './ComicCard';
import { hotComics } from '@/mocks/comics';

const tabs = ['综合', '热血', '治愈', '悬疑', '奇幻'];

export default function HotRanking() {
  const [active, setActive] = useState('综合');

  const filtered = active === '综合' ? hotComics : hotComics.filter((c) => c.genre.includes(active));
  const topThree = filtered.slice(0, 3);
  const rest = filtered.slice(3);

  return (
    <section id="hot" className="w-full bg-background-900/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
              <i className="ri-fire-fill" />
              HOT RANKING
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              人气作品榜
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400 md:text-base">
              站内人气与口碑综合榜单，按口味一键切换，看看大家最近都在追什么。
            </p>
          </div>

          <div className="inline-flex items-center gap-1 rounded-full border border-background-800 bg-background-950 p-1">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === tab
                    ? 'bg-primary-500 font-bold text-foreground-950'
                    : 'text-foreground-400 hover:text-foreground-100'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {topThree.map((comic, i) => (
            <ComicCard key={comic.id} comic={comic} rank={i + 1} />
          ))}
        </div>

        {rest.length > 0 && (
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            {rest.map((comic, i) => (
              <ComicCard key={comic.id} comic={comic} rank={i + 4} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}